import { AppBar, Box, Toolbar, styled } from '@mui/material';

import { NavLink, useLocation } from 'react-router-dom';

import DesktopHeader from './header-components/DesktopHeader';
import MobileHeader from './header-components/MobileHeader';
import React, { useEffect, useState } from 'react';
import GetRecords from '../../lib/api/GetRecords';
import { APIS } from '../../lib/constants/apis';
import { get } from 'lodash';
import { getLocalstorageToken, isUserLoggedIn } from '../../context/AuthHelper';

export const StyledToolbar = styled(Toolbar)({
	display: 'flex',
	justifyContent: 'space-between',
	backgroundColor: '#1E1B1B',
});
export const NavLinksContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'center',
	[theme.breakpoints.up('lg')]: {
		position: 'absolute',
		right: '7.5rem',
		top: 0,
		transform: 'translateX(-50%)',
		maxWidth: 1140,
	},
}));
export const NavLinkStyled = styled(NavLink)(({ theme }) => ({
	padding: theme.spacing(2.8, 2),
	color: theme.palette.navbar.primary.main,
	textDecoration: 'none',
	borderBottom: `2px solid transparent`,
	'&.active': {
		color: theme.palette.navbar.primary.active,
		borderBottom: `2px solid ${theme.palette.navbar.primary.active}`,
	},
}));

function Header() {
	const location = useLocation();
	const [unreadMessage, setUnreadMessage] = useState(0);
	useEffect(() => {
		const fetchNachricht = async () => {
			try {
				let fields = ['id'];
				let filterOption = {
					Antragstellende: { id: { $eq: get(getLocalstorageToken(), 'organisationId') } },
					Allgemein_Ordner: 'Posteingang',
					Allgemein_gelesen: 'false',
				};
				let pagination = {
					start: 0,
					limit: 1,
					withCount: true,
				};
				let res = await GetRecords(APIS['Portal-Nachricht'], [], filterOption, [], pagination, fields);
				setUnreadMessage(get(res, 'meta.pagination.total', 0));
			} catch (err: any) {
				console.error('ERROR: Fetching Nachricht ', err);
			}
		};

		if (isUserLoggedIn()) fetchNachricht();
	}, [location]);
	return (
		<>
			<AppBar position="sticky">
				<Box sx={{ display: { xs: 'none', md: 'block' } }}>
					<DesktopHeader unreadMessage={unreadMessage} />
				</Box>
				<Box sx={{ display: { xs: 'block', md: 'none' } }}>
					<MobileHeader />
				</Box>
			</AppBar>
		</>
	);
}

export default Header;
